import { useEffect, useState } from "react";
import { apiFetch } from "../../../utils/api";

export const useLiveDiscovery = (query, country, dateRange, enabled) => {
  const [data, setData] = useState(null), [error, setError] = useState(""), [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true, timer;
    setData(null); setError("");
    if (!enabled) return;
    const accept = result => {
      if (!active) return;
      setData(result.data);
      if (result.data.status === "pending") timer = setTimeout(() => {
        apiFetch(`/api/search/discover/${result.data.id}`).then(accept).catch(() => { if (active) setError("Live source lookup was interrupted."); });
      }, 1800);
    };
    apiFetch("/api/search/discover", { method: "POST", body: JSON.stringify({ query, country: country || null, date_range: dateRange || "all" }) }).then(accept).catch(() => { if (active) setError("Live source lookup is unavailable. Your indexed results remain available."); });
    return () => { active = false; clearTimeout(timer); };
  }, [query, country, dateRange, enabled, retry]);
  return { data, error, retry: () => setRetry(value => value + 1) };
};